import React from 'react';
import styles from './spinnerLoading.css';

export const SpinnerLoading: React.FC = () => (
  <div className={styles.container} data-test-id="loader-spinner">
    <span className={styles.loader} />
  </div>
);
